import { render } from "./ReviewEditor.vue?vue&type=template&id=a5e2216c&scoped=true"
import script from "./ReviewEditor.vue?vue&type=script&lang=js"
export * from "./ReviewEditor.vue?vue&type=script&lang=js"

import "./ReviewEditor.vue?vue&type=style&index=0&id=a5e2216c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e2216c"]])

export default __exports__